var map = {
	"./Draft.png": 17609,
	"./Inbox.png": 29683,
	"./Sent.png": 4221,
	"./Spam.png": 21456,
	"./Started.png": 2218,
	"./Trash.png": 99300,
	"./message.png": 8824,
	"./search.png": 66024
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 70729;